module.exports = __webpack_public_path__ + "static/Ellicott-Hero-aa0896c1466a79a3b4f40104fd0e4208.jpg";